import { render, staticRenderFns } from "./JPopup.vue?vue&type=template&id=c200a8a4&scoped=true"
import script from "./JPopup.vue?vue&type=script&lang=js"
export * from "./JPopup.vue?vue&type=script&lang=js"
import style0 from "./JPopup.vue?vue&type=style&index=0&id=c200a8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c200a8a4",
  null
  
)

export default component.exports